export enum ClearMode {
    Single = 'single',
    Range = 'range',
    Relative = 'relative'
  }